import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { GTM_CAMPAIGNS_ANALYSIS_STEP } from '@/features/gtm/domain/gtm-run-stages'
import { requireGtmWorkspace } from '@/shared/lib/gtm-route-guard'

const searchSchema = z.object({ project: z.string().uuid().optional() })

export const Route = createFileRoute(
  '/$lang/workspace/$workspaceId/gtm/campaigns',
)({
  validateSearch: (search) => searchSchema.parse(search),
  // Campaigns are part of Analysis (its campaigns stage) now.
  beforeLoad: async ({ context, params, search }) => {
    await requireGtmWorkspace(context, params)
    throw redirect({
      to: '/$lang/workspace/$workspaceId/gtm',
      params,
      search: { project: search.project, step: GTM_CAMPAIGNS_ANALYSIS_STEP },
      replace: true,
    })
  },
  staticData: { layout: 'main' },
})
